export const hotlinePhone = '800 400 120';
export const hotlineEmail = 'tym@reas.cz';
export const infoEmail = 'info@reas.cz';
